import { isPathLookupEdgeData } from '@ipfabric/utils';
import type { PacketDetailMouseEvent } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetail';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { unhighlightEdges } from '../pathLookup/unhighlightEdges';
import { getIncomingEdgeIds } from './helpers/getIncomingEdgeIds';

export const pathLookupDetailPreviousButtonMouseLeave: GraphCommandFactory<
  PacketDetailMouseEvent
> = (cmdContext, dispatch) => (command) => {
  const foundEdge = cmdContext.getState().graph.edges[command.detailId];
  if (foundEdge === undefined || !isPathLookupEdgeData(foundEdge)) {
    return;
  }

  const foundNode = cmdContext.getState().graph.nodes[foundEdge.source];
  if (foundNode === undefined) {
    return;
  }

  const incomingEdgeIds = getIncomingEdgeIds(
    cmdContext.getState(),
    command.detailId,
    foundNode.id,
  );

  if (incomingEdgeIds === undefined || incomingEdgeIds.length === 0) {
    return;
  }

  // Unhighlight incoming edges from previous node
  dispatch(unhighlightEdges, { edges: incomingEdgeIds });
};
